import React, {useState,  useRef, useEffect} from "react";
import $ from "jquery";
import '../css/Top.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane,faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';

const Side = ({isSidebarExpanded, isSidebarHovered, setIsSidebarHovered}) => {
	const shouldBeExpanded = isSidebarExpanded || isSidebarHovered;
	const [isExpanded, setIsExpanded] = useState(false);
	const contentRef = useRef(null);
	const dropdown_toggle = () => {
    setIsExpanded(!isExpanded);
  };

   useEffect(() => {
    const $el = $(contentRef.current);

    if (isExpanded) {
      $el.stop(true, true).slideDown(300);
    } else {
      $el.stop(true, true).slideUp(300);
    }
  }, [isExpanded]);

   const sidebtn = (e) => {
	  // Avoid double trigger if <a> or <Link> was clicked directly
	  if (e.target.tagName.toLowerCase() === 'a') return;

	  // Find the <a> inside the clicked <li>
	  const link = e.currentTarget.querySelector('a');

	  if (link) {
	    if (link.target === '_blank') {
	      window.open(link.href, '_blank');
	    } else {
	      link.click(); // for react-router-dom's <Link> or normal links
	    }
	  }
	};

	return(
		<div className={`container-fluid side-nav d-flex flex-column justify-content-start align-items-center ${shouldBeExpanded ? 'expanded' : 'collapsed'}`} onMouseEnter={() => setIsSidebarHovered(true)} onMouseLeave={() => setIsSidebarHovered(false)}>
			

			<span className="nav-brand d-flex align-items-center big-font">
				<FontAwesomeIcon icon={faPaperPlane} size="lg" color="black" />
				{shouldBeExpanded && (
						<span>Task Management</span>
					)}
			</span>

			<div style={{ width: "100%",padding: "15px 5px"}}>
				<div className="d-flex align-items-center" style={{ backgroundColor: "#d2d9db", height: "45px", width: "100%", borderRadius: "15px", padding: "20px", gap: "20px", cursor: "pointer"}} onClick={dropdown_toggle}>
					<img src='img/calendar.png' width="15px" height="15px" />
					{shouldBeExpanded && (
						<div className="d-flex flex-nowrap justify-content-between align-items-center" style={{width: "100%"}}>
							<p style={{margin:"0px"}}>Tasks</p>
							<FontAwesomeIcon icon={isExpanded ? faChevronUp : faChevronDown} fontSize="10px" color="black" />						
						</div>
					)}

				</div>

					<div ref={contentRef} className={`sidebar-content col-md-12 ${shouldBeExpanded ? '' : 'd-none'}`}>
				  <ul>
				    <li className="side-btn col-md-12" onClick={sidebtn}>
				      <a href="http://localhost/taskb_v2/en/task/?act=new_task" target="_blank" rel="noopener noreferrer">Task</a>
				    </li>
				    <li className="side-btn col-md-12" onClick={sidebtn}>
				      <a href="http://localhost/taskb_v2/en/task/?act=new_task&is_super_admin=1" target="_blank" rel="noopener noreferrer">Super Admin</a>
				    </li>
				    <li className="side-btn col-md-12" onClick={sidebtn}>
				      <a href="http://localhost/taskb_v2/en/catalog/?act=styles&tab=products" target="_blank" rel="noopener noreferrer">Catalog Style Page</a>
				    </li>
				    <li className="side-btn col-md-12" onClick={sidebtn}>
				      <Link to="/tsd">TSD</Link>
				    </li>
				  </ul>
				</div>


			</div>

			<div className={`side-bg ${shouldBeExpanded ? '' : 'hide'}`} style={{marginTop:"auto"}}><img src='img/side_bg6.jpg' width="100%" height="auto" /></div>
			
		</div>

	)
}

export default Side;